const AddressCard = ({ address, isSelected, onSelect, onEdit, onDelete }) => {
  return (
    <div
      onClick={onSelect}
      className={`relative rounded-2xl p-4 cursor-pointer transition-all duration-200 border-2 ${
        isSelected
          ? "border-[#7B1520] bg-rose-50 shadow-md"
          : "border-gray-100 bg-white hover:border-gray-300 hover:shadow-sm"
      }`}
    >
      {/* Selected indicator */}
      <div className={`absolute top-3 right-3 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all ${
        isSelected ? "border-[#7B1520] bg-[#7B1520]" : "border-gray-300 bg-white"
      }`}>
        {isSelected && (
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M2 5l2 2.5L8 3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
      </div>

      {/* Address info */}
      <p className={`font-semibold text-sm pr-8 ${isSelected ? "text-[#7B1520]" : "text-gray-800"}`}>
        {address.name}
        {address.default && (
          <span className="ml-2 text-[10px] font-bold text-green-600 bg-green-100 px-1.5 py-0.5 rounded-full">Default</span>
        )}
      </p>

      <p className="text-xs text-gray-500 mt-1.5 leading-5">
        {address.areaLocation}, {address.city}, {address.state} — {address.pincode}
      </p>
      <p className="text-xs text-gray-500 mt-0.5">📞 {address.phoneNumber}</p>

      {/* Actions */}
      <div className="flex gap-3 mt-3" onClick={(e) => e.stopPropagation()}>
        <button onClick={onEdit} className="text-xs text-blue-600 font-semibold hover:underline">
          Edit
        </button>
        <button onClick={onDelete} className="text-xs text-red-500 font-semibold hover:underline">
          Delete
        </button>
      </div>
    </div>
  );
};

export default AddressCard;
